import { useEffect, useState } from 'react';

import { transcriptorApi } from '@/shared/api/transcriptor';
import { debug } from '@/shared/lib';

const loadRecordingCapabilities = (organizationId: string) =>
  transcriptorApi
    .getRecordingCapabilities(organizationId)
    .catch(() => transcriptorApi.getRecordingCapabilities(organizationId));

// Whether the clinic may dictate: `undefined` while it is not known, also
// after a failed request, so only the server's explicit `false` hides
// Dictation.
export const useRecordingCapabilities = (
  organizationId: string,
  enabled: boolean,
): boolean | undefined => {
  const [capability, setCapability] = useState<{
    organizationId: string;
    dictationEnabled: boolean;
  }>();

  useEffect(() => {
    if (!organizationId || !enabled) {
      return;
    }
    let active = true;
    loadRecordingCapabilities(organizationId).then(
      (value) => {
        if (active) {
          setCapability({ organizationId, ...value });
        }
      },
      (error) => debug('Recording capabilities are unknown', error),
    );
    return () => {
      active = false;
    };
  }, [organizationId, enabled]);

  if (!enabled) {
    return false;
  }
  return capability?.organizationId === organizationId
    ? capability.dictationEnabled
    : undefined;
};
